import React, { useState } from "react"
import TitleSection from "../title-section";
import { ReferenciaContenido } from '../../../interfaces/ReferenciaContenido';
import "./recomendationList.scss"

const RecomendationList = (props : ReferenciaContenido) => {
    console.log(props);
    const blockName: string = "m-recomendation-list";
    const [showedLimit, setShowedLimit] = useState<number>(5);
    const onClickAction : ()=> void = () => {
        showedLimit === 5 ? setShowedLimit(100) : setShowedLimit(5);
    }

    return(
        <section className={`${blockName} ${showedLimit === 5 ? "": "m-recomendation-list--expanded"}`}>
            <div className={`${blockName}__title`}>
                <TitleSection title={props.tituloGeneral} />
            </div>
            <figure className={`${blockName}__container`}>
                <img src={props.imagenPrincipal.file.url} className={`${blockName}__img ${showedLimit === 5 ? "": "m-recomendation-list__img--expanded"}`}/>
            </figure>
            <ul className={`${blockName}__list`}>
                {props.descripcion.json.content[0].content.map((item, index)=> 
                    index < showedLimit && <li className={`${blockName}__item`}><img src={props.listaImagenes[0].file.url}/><span>{item.content[0].content[0].value}</span></li>
                )}
                <button className={`${blockName}__button`} onClick={onClickAction}>Ver {showedLimit === 5 ? "más" : "menos"}</button>
            </ul>
        </section>
    );
};

export default RecomendationList;
